module.exports = __webpack_public_path__ + "static/img/bankcard.627cf0f6.png";